import React, {useState, useEffect} from 'react'
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {isAuth} from "../../Utils/firebaseUtils";
import firebase from "firebase";
import {MDBAlert, MDBBtn, MDBCol, MDBContainer, MDBRow, MDBSpinner} from "mdbreact";
import {Trans} from "react-i18next";

import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";
import ResultItem from "../CategoryPage/ResultItem/ResultItem";
import ContentLoader from "react-content-loader";
import classes from '../CategoryPage/CategoryPage.module.css'
import {getCategoryDisplayName} from "../../Utils/category";
import {Capacitor} from "@capacitor/core";
const db = firebase.firestore()

let condition = {
    type: ""
}

const Newest = (props) => {
    const [allResult, setAllResult] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [noItem, setNoItem] = useState(false)
    const [noMoreItem, setNoMoreItem] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [mode, setMode] = useState("grid")

    useEffect(() => {
        let searchStr = new URLSearchParams(props.location.search)

        if (searchStr.has("type")) {
            condition = {
                ...condition,
                type: searchStr.get("type")
            }
        }
        else{
            condition = {
                ...condition,
                type: ""
            }
        }
        getItems( condition)
    }, [props.history.location.search])

    useEffect(() => {
        getItems(condition)
    }, [])

    const getItems = (condition, isNext, nextCreateDate) => {
        let ref = db
            .collection('Data')
            .orderBy('createDate',"desc")
            .limit(12)

        if (condition.type !== '') {
            setAllResult([])
            setIsLoaded(false)
            ref = ref.where("type", "==", condition.type)
        }

        if (isNext) {

            setIsLoading(true)
            ref
                .startAfter(nextCreateDate)
                .get()
                .then(res => {
                    setIsLoading(false)
                    if (!res.empty) {
                        let allItem = []
                        res.forEach(doc => {
                            allItem.push({
                                ...doc.data(),
                                id: doc.id
                            })
                        })
                        let newAllResult = allResult.concat(allItem)
                        setAllResult(newAllResult)
                        // setIsLoaded(true)
                    } else {
                        setNoMoreItem(true)
                        // setIsLoaded(true)
                    }
                })
                .catch(err => console.log(err))
        }
        else{

            setNoMoreItem(false)
            ref
                .get()
                .then(res => {
                    if (!res.empty) {
                        let allItem = []
                        res.forEach(doc => {
                            allItem.push({
                                ...doc.data(),
                                id: doc.id
                            })
                        })
                        setAllResult(allItem)
                        setIsLoaded(true)
                    } else {
                        setNoItem(true)
                        setIsLoaded(true)
                    }
                })
                .catch(err => console.log(err))
        }
    }


    return (
        <MDBContainer>
            <Helmet>
                <title> { returnTran("Newest", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}</title>
                {/*<meta property="fb:app_id" content="1293953327456577" />*/}
                <meta property="og:type" content="website" />
                <meta property="site_name" content="MeWeSearcher" />
                <meta property="title" content={ returnTran("Newest", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                <meta name="description" content={ returnTran("Newest", "description")}/>
                <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                <meta property="og:title"
                      content={ returnTran("Newest", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                <meta property="og:description" content={ returnTran("Newest", "description")}/>
                <meta property="og:url" content={"https://mewesearcher.com" + window.location.pathname}/>
                <meta property="og:site_name"
                      content={"MeWeSearcher | " + returnTran("Newest", "description")}/>
                {/*<meta property="og:updated_time"*/}
                {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                <meta httpEquiv="content-language"
                      content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                <meta property="og:type" content="article"/>
                <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                <meta property="og:image:width" content="1280"/>
                <meta property="og:image:height" content="720"/>
                {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
            </Helmet>

            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <h1 className={classes.H1}>
                        <Trans>Newest.title</Trans>
                    </h1>
                    <div className={classes.ButtonGroup}>
                        <Link
                            to={props.location.pathname + '?' + condition.type === "page" ? "" : "?type=" + "page"}>
                            <MDBBtn color={'primary'}
                                    outline={condition.type === "page"}
                                    className={classes.SubCateBtn}
                            >
                                <Trans>ResultItem.page</Trans>
                            </MDBBtn>
                        </Link>

                        <Link
                            to={props.location.pathname + '?' + condition.type === "group" ? "" : "?type=" + "group"}>
                            <MDBBtn color={'primary'} className={classes.SubCateBtn}
                                    outline={condition.type === "group"}
                            >

                                <Trans>ResultItem.group</Trans>
                            </MDBBtn>
                        </Link>
                    </div>


                    <div className={classes.ResultContainer}>
                        {
                            isLoaded ?
                                !noItem ?
                                    allResult.map((data,index) => {
                                        if(index%3 ===0 && index !== 0 && Capacitor.getPlatform() === "web"){
                                            return(
                                                <React.Fragment key={'adc' + index}>
                                                    <ResultItem
                                                        isAd={true}

                                                    />
                                                    <ResultItem
                                                        setModalController={props.setModalController}
                                                        mode={mode}
                                                        key={data.id}
                                                        data={data}
                                                    />
                                                </React.Fragment>
                                            )
                                        }
                                        else{
                                            return (
                                                <ResultItem
                                                    setModalController={props.setModalController}
                                                    mode={mode}
                                                    key={data.id}
                                                    data={data}
                                                />
                                            )
                                        }

                                    })
                                    :
                                    <MDBAlert className={classes.NoRecordAlert}>
                                        <Trans>CategoryPage.no-record</Trans>
                                    </MDBAlert>
                                :
                                mode === 'grid' ?
                                    <ContentLoader
                                        speed={2}
                                        width={350}
                                        height={220}
                                        viewBox="0 0 400 160"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                    >
                                        <rect x="5" y="5" rx="10" ry="10" width="350" height="220"/>
                                        <rect x="425" y="5" rx="10" ry="10" width="350" height="220"/>
                                        <rect x="5" y="240" rx="10" ry="10" width="350" height="220"/>
                                    </ContentLoader>
                                    :
                                    <ContentLoader
                                        speed={2}
                                        width={400}
                                        height={160}
                                        viewBox="0 0 400 160"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                    >
                                        <rect x="5" y="5" rx="10" ry="10" width="400" height="180"/>
                                        <rect x="425" y="5" rx="10" ry="10" width="400" height="180"/>
                                        <rect x="5" y="195" rx="10" ry="10" width="400" height="180"/>
                                    </ContentLoader>

                        }

                        {
                            noMoreItem ?
                                <MDBAlert>
                                    <Trans>CategoryPage.no-record</Trans>
                                </MDBAlert>
                                :
                                !noItem ?
                                    <button className={classes.MoreBtn} onClick={() => {
                                        getItems( condition, true, allResult[allResult.length - 1].createDate)
                                    }}>
                                        {isLoading ? <MDBSpinner/> : <Trans>CategoryPage.more-record</Trans>}
                                    </button>
                                    : ""
                        }


                    </div>
                </MDBCol>
            </MDBRow>

        </MDBContainer>
    )

}
const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}
const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)


export default enhance(withRouter(Newest))